(function () {
  function swiperSlider(scope = document) {
    const swiperContainers = scope.querySelectorAll(
      '[id^="section-id-"] .swiper-container'
    );

    swiperContainers.forEach((swiperContainer) => {
      const slides = swiperContainer.querySelectorAll(".swiper-slide");

      if (!slides.length) {
        swiperContainer.style.display = "none";
        return;
      }

      // Prevent duplicate initialization
      if (swiperContainer.swiper) {
        swiperContainer.swiper.update();
        return;
      }

      new Swiper(swiperContainer, {
        slidesPerView: 2,
        spaceBetween: 24,
        loop: false,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
          el: '.swiper-pagination',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          480: {
            slidesPerView: 2.5,
          },
          767: {
            slidesPerView: 3,
          },
          1025: {
            slidesPerView: 3.6,
          },
        },
      });
    });
  }

  function tabInitSection(scope = document) {
    const sections = scope.querySelectorAll('[id^="section-id-"]');

    sections.forEach((section) => {
      const tabs = section.querySelectorAll(".tab-nav .collection-tab-link");
      const shopAllItems = section.querySelectorAll(".tab-nav .shop-all-item");
      const panes = section.querySelectorAll(".tab-pane");

      if (!tabs.length) return;

      function activateTab(tab) {
        const targetSelector = tab.getAttribute("href");
        const targetPane = section.querySelector(targetSelector);

        if (!targetPane) return;

        tabs.forEach((t) => t.classList.remove("active"));
        shopAllItems.forEach((item) => item.classList.remove("active"));
        panes.forEach((p) => p.classList.remove("active"));

        tab.classList.add("active");
        targetPane.classList.add("active");

        const activeShopAllItem = section.querySelector(
          `.tab-nav .shop-all-item[data-collection-tab="${tab.dataset.collectionTab}"]`
        );

        if (activeShopAllItem) {
          activeShopAllItem.classList.add("active");
        }

        // Update Swiper after pane becomes visible
        requestAnimationFrame(() => {
          const swiper = targetPane.querySelector(".swiper-container")?.swiper;

          if (swiper) {
            swiper.update();
            swiper.slideTo(0, 0);
          }

          // Notify GSAP that active tab changed
          section.dispatchEvent(
            new CustomEvent("collectionTabChanged", {
              detail: {
                section,
                pane: targetPane,
              },
            })
          );
        });
      }

      tabs.forEach((tab) => {
        if (tab.dataset.bound) return;

        tab.dataset.bound = "true";

        tab.addEventListener("click", function (e) {
          e.preventDefault();
          activateTab(this);
        });
      });

      const activeTab =
        section.querySelector(".tab-nav .collection-tab-link.active") ||
        tabs[0];

      activateTab(activeTab);
    });
  }

  function initCollectionTabs(scope = document) {
    swiperSlider(scope);
    tabInitSection(scope);
  }

  document.addEventListener("DOMContentLoaded", () => {
    initCollectionTabs();
  });

  if (window.Shopify && Shopify.designMode) {
    [
      "shopify:section:load",
      "shopify:section:select",
      "shopify:block:select",
    ].forEach((eventName) => {
      document.addEventListener(eventName, (e) => {
        initCollectionTabs(e.target || document);
      });
    });
  }
})();
